import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
//import { NgwWowService } from 'ngx-wow';
import { DataService, EmmiterService } from 'src/app/services/data.service';
import { HttpParams } from '@angular/common/http';
import { CommonService } from 'src/app/services/common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { NavigationExtras, Router } from '@angular/router';
import { AdvanceGridviewComponent } from 'src/app/shared/components/advance-gridview/advance-gridview.component';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import {MemoryStorageService} from 'src/app/services/memory-storage.service';

@Component({
  selector: 'app-change-process',
  templateUrl: './change-process.component.html',
  styleUrls: ['./change-process.component.css']
})
export class ChangeProcessComponent implements OnInit {

  //lstDropDown: any = [];
  docTypeList: any = [];
  docTypeListMst: any = [];
  processTypeList: any = [];
  nextprocessTypeList: any = [];
  strURN: string = '';
  strComments: string = '';
  selectedDocumentType: any;
  selectedProcessType: any;
  selectednextProcessType: any;
  lstURNData: any = [];
  chnageTypeColumnsToHide: any = ['DOCUMENT_DETAIL_ID', 'PROCESS_ID'];
  selectedRecords: any = [];
  restrictedKeywords: any = [];
  isCommentExpand: boolean = false;
  isSubDocumentExists: boolean = false;
  modalReference: any;
  isDataFound: boolean = false;
  isApproved: boolean = false;
  // WorkITem Creation Range
  isWorkItemDateRangeHasValue = false;
  isDisplayTransactionData = false;
  maxDate = new Date();
  workItemCreationDateRange = new FormGroup({
    work_item_start_date: new FormControl(),
    work_item_end_date: new FormControl(),
  });

  lstProcessData = [];
  lstHeaders = [];
  lstHeaders_log = [];

  advanceSearchSummaryFields: any = [];
  advanceSearchFilterFields: any = [];
  advanceSearchSummaryStaticFields: any = {
    URN: "",
    Priority: "",
    SOURCE: "",
    FROM_EMAIL: "",
    Created_Dt_From: "",
    Created_Dt_To: ""
  };


  // Invoice Creation Range
  isDateRangeHasValue = false;
  //maxDate = new Date();
  invoiceCreationDateRange = new FormGroup({
    start_date: new FormControl(),
    end_date: new FormControl(),
  });
  isNextqueueEnable = false;
  isCommentMandatory: boolean = false;
  strRange: string = '1-9999999';
  // word count var start
  wordsTotal: any = 1000;
  // word count ver end
  @ViewChild('invoiceSubmittedModal') invoiceSubmittedModal: ElementRef;
  @ViewChild('gridTransactionData') gridAllocationData: AdvanceGridviewComponent;

  constructor(
    //private wowService: NgwWowService,
    private dataService: DataService,
    private commonService: CommonService,
    private modalService: NgbModal,
    private route: Router,
    private encryptDecryptservice: EncryptDecryptService,
    private memorystore: MemoryStorageService
  ) {
    //wowService.init();
  }

  ngOnInit(): void {
    this.restrictedKeywords = this.commonService.getRestrictedKeywords();
    this.getDocumentTypes();
    this.getProcessTypes();
  }
  // add word count function start
  function(data) {
    this.wordsTotal = this.wordsTotal - data.length
  }
  // add word count function end

  getDocumentTypes() {

    let params = new HttpParams();
    // params = params.append('project_id', this.commonService.selectedProject);
    // params = params.append('subgroup_id', this.commonService.selectedSubgroup);
    params = params.append('project_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject));
    params = params.append('xusrid', this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')));
    params = params.append('subgroup_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedSubgroup));
    this.dataService.getData('document-types', params).subscribe(
      (res) => {
        if (res != null && (res.error_message == null || res.error_message == "")) {
          if (res.data != null) {
            this.docTypeListMst = res.data;
            this.docTypeList = [];
            res.data.forEach((element) => {
              this.docTypeList.push({
                value: element.document_type_id,
                text: element.document_type_name
              });
            });

            this.selectedDocumentType = this.docTypeList.length > 0 ? this.docTypeList[0].value : '';
            this.isCommentMandatory = this.docTypeListMst[0].is_comment_mandatory_for_change_queue;
            this.onSelectDocumentType(this.selectedDocumentType);
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.route.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      },
      error => {
        if (error.includes("401")) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
      }
    );
  }

  getProcessTypes() {
    let params = new HttpParams();
    params = params.append('project_id', this.commonService.selectedProject);
    this.dataService.getData('get-process-change-from', params).subscribe(
      (res) => {
        if (res != null && res.data != null) {
          this.processTypeList = [];
          this.processTypeList.push({
            value: 0,
            text: '--Select--'
          });
          res.data.forEach((element) => {
            this.processTypeList.push({
              value: element.process_id,
              text: element.process_name
            });
          });

          this.selectedProcessType = this.processTypeList.length > 0 ? this.processTypeList[0].value : '';
          this.onSelectProcessType(this.selectedProcessType);

        }

      },
      (el) => {
      }
    );
  }

  getNextProcessTypes() {
    this.nextprocessTypeList = [];
    let params = new HttpParams();
    params = params.append('project_id', this.commonService.selectedProject);
    params = params.append('subgroup_id', this.commonService.selectedSubgroup);
    params = params.append('document_type_id', this.selectedDocumentType);
    params = params.append('process_id', this.selectedProcessType);
    params = params.append('role_id', this.commonService.selectedRole);
    params = params.append('projectmodule', 'AP');

    this.dataService.getData('get-nextprocess-type', params).subscribe(
      (res) => {
        if (res != null && res.data != null) {
          res.data.forEach((element) => {
            this.nextprocessTypeList.push({
              value: element.process_id,
              text: element.process_name
            });
          });

          this.selectednextProcessType = this.nextprocessTypeList.length > 0 ? this.nextprocessTypeList[0].value : '';
          this.onSelectnextProcessType(this.selectedProcessType);
        }

      },
      (el) => {
      }
    );
  }

  onSelectProcessType(docId) {
    if (this.lstURNData.length > 0) {
      this.lstURNData.splice(0, this.lstURNData.length)
    }
    if (docId > 0) {
      // this.getNextProcessTypes()
    }

    //this.isDataFound = false;
  }

  onSelectnextProcessType(docId) {
    // if (this.lstURNData.length > 0) {
    //   this.lstURNData.splice(0, this.lstURNData.length)
    // }
    if (docId > 0) {
      // this.getNextProcessTypes()
    }

    //this.isDataFound = false;
  }

  async onSelectDocumentType(docId) {

    this.isCommentMandatory = this.docTypeListMst.find(x => x.document_type_id == docId).is_comment_mandatory_for_change_queue;
    await this.getAdvanceSearchFields(true);
  }

  async getAdvanceSearchFields(isSummarySearch: boolean) {

    let reqData = {
      project_id: this.commonService.selectedProject,
      subgroup_id: this.commonService.selectedSubgroup,
      document_type_ids: this.selectedDocumentType,
    };

    await this.dataService.getDataPromise('advanced-search-fields', reqData).then((res) => {
      if (res != null && res.data != null) {
        if (isSummarySearch) {
          this.advanceSearchSummaryFields = res.data;
          this.advanceSearchSummaryFields.forEach(async (element) => {
            element['search_value'] = '';
            if (element.control_type == 'TEXTBOX') {
              element.value_type = element.validation_type == 'NUMERIC' ? 'number' : 'text';
            }

            if (element.control_type == 'DROPDOWN') {
              element.options = await this.commonService.getDropdownData(element.field_mapping_detail_id);
              element.options.splice(0, 0, { id: 0, name: '-- Select --' });
            }
          });
          if (this.advanceSearchFilterFields.length > 0) {
            this.advanceSearchFilterFields.forEach((element) => {
              if (this.advanceSearchSummaryFields.findIndex((x) => x.db_column_name == element.db_column_name) > -1) {
                this.advanceSearchSummaryFields.find((x) => x.db_column_name == element.db_column_name).search_value = element.search_value;
              }
            });
          }
        } else {
          this.advanceSearchFilterFields = res.data;
          this.advanceSearchFilterFields.forEach(async (element) => {
            element['search_value'] = '';
            if (element.control_type == 'TEXTBOX') {
              element.value_type = element.validation_type == 'NUMERIC' ? 'number' : 'text';
            }
            if (element.control_type == 'DROPDOWN') {
              element.options = await this.commonService.getDropdownData(element.field_mapping_detail_id);
              element.options.splice(0, 0, { id: 0, name: '-- Select --' });
            }
          });
        }
      }
    });
  }

  getOpenSearchData() {
    this.lstURNData = [];
    this.lstHeaders = [];
    this.selectedRecords = [];
    let searchColumns = {};
    this.isDataFound = false;
    this.isDisplayTransactionData = true;

    this.advanceSearchSummaryFields.forEach((field) => {
      if (field.search_value != '') {
        if (field.control_type == 'DATE') {
          field.search_value = this.commonService.dateFormating(
            field.search_value
          );
        }
        searchColumns[field.db_column_name] = field.search_value.toString();
      }
    });
    let invalidSubmitMsg = '';

    let objDocType = this.docTypeList.find(el => el.value == this.selectedDocumentType);

    invalidSubmitMsg += typeof objDocType !== "undefined" && objDocType.value != 0 ? '' : '-Please select work item type.\r <br/>';
    if (invalidSubmitMsg != '') {
      this.commonService.showMessageBox(invalidSubmitMsg, 'Queue Change');

    }
    else {

      let invoice_dateRange: any = { start_date: '', end_date: '' };
      let invoice_dt: string = "";

      if (this.isDateRangeHasValue) {
        invoice_dateRange = {
          start_date: this.commonService.dateFormating(
            this.invoiceCreationDateRange.value.start_date
          ),
          end_date: this.commonService.dateFormating(
            this.invoiceCreationDateRange.value.end_date
          ),
        };
        invoice_dt = invoice_dateRange.start_date + '/' + invoice_dateRange.end_date;

      }
      let create_dateRange: any = { start_date: '', end_date: '' };

      let create_dt: string = "";
      if (this.isWorkItemDateRangeHasValue) {
        create_dateRange = {
          start_date: this.commonService.dateFormating(
            this.workItemCreationDateRange.value.work_item_start_date
          ),
          end_date: this.commonService.dateFormating(
            this.workItemCreationDateRange.value.work_item_end_date
          ),
        };
        create_dt = create_dateRange.start_date + '/' + create_dateRange.end_date;
      }
      let parentSearchField = this.advanceSearchSummaryStaticFields;
      let priority = [];
      if (parentSearchField.Priority != "") {
        priority.push(parentSearchField.Priority)
      }

      let indexRange: any;
      indexRange = this.strRange.split('-');
      if (indexRange.length != 2) {
        this.commonService.showMessageBox("Please enter valid range like (1-9999999)", 'Alert');
        return;
      }

      if (isNaN(indexRange[0]) == true) {
        this.commonService.showMessageBox("Please enter valid number in range", 'Alert');
        return;
      }

      if (isNaN(indexRange[1]) == true) {
        this.commonService.showMessageBox("Please enter valid number in range.", 'Alert');
        return;
      }
      if (indexRange[0] == 0 || indexRange[1] == 0) {
        this.commonService.showMessageBox("Please enter valid number in range.", 'Alert');
        return;
      }

      if (indexRange[0] > indexRange[1]) {
        this.commonService.showMessageBox("Please enter valid range.", 'Alert');
        return;
      }


      let obj = {
        action: "FILTER",
        projectId: this.commonService.selectedProject,
        documentTypeId: this.selectedDocumentType,
        process_ids: this.selectedProcessType.toString(),
        urn: this.strURN,
        durationCreateDate: create_dt,
        durationInvoiceDate: invoice_dt,
        role_id: this.commonService.selectedRole,
        search_columns: searchColumns,
        priority: [],
        source: "",
        from_email: "",
        date_range: null,
        from_range: Number(indexRange[0]),
        to_range: Number(indexRange[1])
      };

      if (this.commonService.readObject(parentSearchField) != null) {
        if (parentSearchField.URN != "") {
          obj.urn = parentSearchField.URN;
          searchColumns["d.urn"] = obj.urn;
        }
        obj.priority = priority;
        obj.source = parentSearchField.SOURCE;
        obj.from_email = parentSearchField.FROM_EMAIL;
        if (this.commonService.readInput(parentSearchField.Created_Dt_From) != "" && this.commonService.readInput(parentSearchField.Created_Dt_To) != "")
          obj.date_range = { "start_date": parentSearchField.Created_Dt_From, "end_date": parentSearchField.Created_Dt_To };
      }

      if (this.lstURNData.length > 0) {
        this.lstURNData.splice(0, this.lstURNData.length)
      }
      // this.commonService.setUserInfoToLocalStorage('allocationGridSearchField', JSON.stringify(this.advanceSearchSummaryFields));
      this.memorystore.setItem('allocationGridSearchField', JSON.stringify(this.advanceSearchSummaryFields));
      this.dataService.postData('getProcessChangeFilter', obj).subscribe(
        (res) => {
          if (res != null && (res.error_message == null || res.error_message == "")) {
            if (res.data != null) {
              if (res.data.length > 0) {
                this.lstHeaders = res.data[0].table_sections;
                this.lstHeaders_log.forEach(sec => {
                  sec.section_fields.forEach(f => {
                    let field = this.lstHeaders.find(x => x.section_name == sec.section_name) ?.section_fields.find(y => y.name == f.name);
                    if (field) {
                      field.is_visible = f.is_visible;
                    }
                  });
                });

                this.lstURNData = res.data[0].table_data;
                if (this.lstURNData.length <= 0) {
                  this.commonService.showMessageBox('No data found', 'Information');
                }
                if (this.lstURNData != undefined && this.lstURNData.length > 0) {
                  this.isDataFound = true;
                }

                this.lstURNData.forEach((element) => {
                  element["action_dropdown_option"] = JSON.parse(element["action_dropdown_option"])
                });

                this.getNextProcessTypes()
              }
              else {
                this.commonService.showMessageBox('No Data Found', 'Queue Change');
                this.isDataFound = false;
              }

            }
            else {
              this.isDataFound = false;
              this.commonService.showMessageBox('No Data Found', 'Queue Change');
            }
          }
          else {
            if (res.errorCode != 0 && res.errorCode == 4000) {
              this.route.navigateByUrl('/unauthorized');
              return;
            }
            if (res.errorCode != 0 && res.errorCode == 3000) {
              this.commonService.showMessageBox("Internal error")
            }
          }
        },
        error => {
          if (error.includes("401")) {
            this.route.navigateByUrl('/unauthorized');
            return;
          }
        }
      );
    }

  }

  ClearOpenSearch() {
    this.strRange = '1-9999999';
    this.strURN = '';
    this.selectedProcessType = this.processTypeList[0].value;
    this.resetInvoiceCreationDateRange();
    this.resetWorkItemCreationDateRange();
    this.selectedDocumentType = this.docTypeList.length > 0 ? this.docTypeList[0].value : '';
    if (this.lstURNData.length > 0) {
      this.lstURNData.splice(0, this.lstURNData.length)
    }
    this.isDataFound = false;

    this.selectedProcessType = this.processTypeList.length > 0 ? this.processTypeList[0].value : '';
    this.onSelectProcessType(this.selectedProcessType);
  }

  onInvoiceCreationDateChanges() {
    if (
      this.invoiceCreationDateRange.value.start_date != '' ||
      this.invoiceCreationDateRange.value.end_date != ''
    ) {
      this.isDateRangeHasValue = true;
    }
  }

  resetInvoiceCreationDateRange() {
    this.invoiceCreationDateRange = new FormGroup({
      start_date: new FormControl(),
      end_date: new FormControl(),
    });
    this.isDateRangeHasValue = false;
  }

  onWorkItemCreationDateChanges() {
    if (
      this.workItemCreationDateRange.value.work_item_start_date != '' ||
      this.workItemCreationDateRange.value.work_item_end_date != ''
    ) {
      this.isWorkItemDateRangeHasValue = true;
    }
  }

  resetWorkItemCreationDateRange() {
    this.workItemCreationDateRange = new FormGroup({
      work_item_start_date: new FormControl(),
      work_item_end_date: new FormControl(),
    });
    this.isWorkItemDateRangeHasValue = false;
  }

  cellClickEvent(event: any) {
    if (event.columnName.toLowerCase() == 'urn') {

      let data = {
        documentDetailId: event.rowData['DOCUMENT_DETAIL_ID'],
        isReadonlyMode: true
      }
      EmmiterService.get("transactionLiteModal").emit(data);

    }
  }

  columnsFilterChangeEvent(lstHeaders: any) {
    this.lstHeaders_log = lstHeaders;
  }

  headercheckboxClickEvent(event: any) {
    if (event != null) {
      if (event.model.checked == true) {
        if (this.selectedProcessType > 0) {
          this.isNextqueueEnable = true;
        }
      }
      else {
        this.isNextqueueEnable = false;
      }
    }

  }

  checkRestrictedKeywords(formControlName: string) {
    let foundedRestrictedKeyword = [];
    var input = this.strComments;
    this.restrictedKeywords.forEach((keyword) => {
      if (input.includes(keyword.restrict)) {
        input = this.replaceAll(input, keyword.restrict, keyword.replace);
        foundedRestrictedKeyword.push(keyword.restrict);
      }
    });
    if (foundedRestrictedKeyword.length > 0) {
      this.strComments = input;
      this.commonService.showMessageBox(
        'We found some restricted keyword(s) entered in Comment.<br>It auto replaced by replacement keywords.<br>Please check given link for restricted keywords.',
        'Warning'
      );
    }
  }

  replaceAll(str, find, replace) {
    var escapedFind = find.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
    return str.replace(new RegExp(escapedFind, 'g'), replace);
  }

  showModal(modelTemplate, modalSize: string = 'lg') {
    this.modalReference = this.modalService.open(modelTemplate, {
      size: modalSize, centered: true, backdrop: 'static',
      keyboard: false
    });
  }

  sumbitData() {

    let invalidSubmitMsg = '';
    if (this.isCommentMandatory && this.strComments == '') {
      invalidSubmitMsg += '-Please enter comment.\r <br/>';
    }

    if (invalidSubmitMsg != '') {
      this.commonService.showMessageBox(invalidSubmitMsg, 'Queue Change');

    }
    else {

      let dataList: any = [];

      this.lstURNData ?.forEach((element) => {

        if (element.action_checkbox_button == true) {
          let newProcessId = 0;
          let nextprocessid = 0;
          element["action_dropdown_option"] ?.forEach(val => {

            if (val.selected) {
              newProcessId = val.value;
            }

          })

          // if(this.isNextqueueEnable && newProcessId>0)
          // {
          //   this.commonService.showMessageBox('Please Unselect CheckAll  or Individual change queue.', 'Queue Change');
          // }

          if (this.isNextqueueEnable) {
            nextprocessid = this.selectednextProcessType;
          }
          else {
            nextprocessid = newProcessId;
          }


          let obj = {
            ProjectId: this.commonService.selectedProject,
            DocumentDetailId: element.DOCUMENT_DETAIL_ID,
            PreviousProcessId: element.PROCESS_ID,
            // NewProcessId: Number(newProcessId),
            NewProcessId: Number(nextprocessid),
            Reason: this.strComments,
            // // UserId: this.commonService.getUserInfoFromLocalStorage('userId')
            // UserId: this.memorystore.getItem('userId')
            UserId:this.memorystore.getItem('userId')
          }
          dataList.push(obj);
        }
      });



      if (dataList.length <= 0) {
        this.commonService.showMessageBox('Please select at least one URN to change the work item.', 'Queue Change');
      }
      else {

        let processIndex = dataList.findIndex(x => x.NewProcessId == 0);
        if (processIndex >= 0) {
          this.commonService.showMessageBox('Please select To Queue for all selected URNs.', 'Queue Change');
        }
        else {

          if (this.isApproved == false) {
            this.showModal(this.invoiceSubmittedModal, 'lg');
          }
          else {

            this.isApproved = false;

            let initial_params = {
              lstParameter: dataList
            }
            this.dataService.postData('postProcessChange', initial_params).subscribe((res) => {
              if (res != null && (res.error_message == null || res.error_message == "")) {
                if (res.status != null) {
                  this.commonService.showMessageBox('Queue changed  for ' + dataList.length + ' URN(s).', 'Queue Change');
                  this.isDataFound = false;
                  this.strComments = "";
                  if (this.lstURNData.length > 0) {
                    this.lstURNData.splice(0, this.lstURNData.length)
                  }
                }
              }
              else {
                if (res.errorCode != 0 && res.errorCode == 4000) {
                  this.route.navigateByUrl('/unauthorized');
                  return;
                }
                if (res.errorCode != 0 && res.errorCode == 3000) {
                  this.commonService.showMessageBox("Internal error")
                }
              }
            },
              error => {
                if (error.includes("401")) {
                  this.route.navigateByUrl('/unauthorized');
                  return;
                }
              });
          }
        }
      }
    }
  }

  processInvoice() {
    this.isApproved = true;
    this.sumbitData();
  }

  advanceSearchClickEvent(parentSearchField: any) {
    this.advanceSearchSummaryStaticFields = parentSearchField;
    this.getOpenSearchData();
  }

  setPaginationLocalStorageEvent() {
    // this.commonService.setUserInfoToLocalStorage("manualallocation_CurrentPage", this.gridAllocationData.currentPage);
    // this.commonService.setUserInfoToLocalStorage("manualallocationSummary_RecordsPerPage", this.gridAllocationData.recordsPerPage);
    this.memorystore.setItem("manualallocation_CurrentPage", this.gridAllocationData.currentPage);
    this.memorystore.setItem("manualallocationSummary_RecordsPerPage", this.gridAllocationData.recordsPerPage);
  }


}

